import { Heading, Text, Img } from "./..";
import React from "react";

export default function FooterInfo({ ...props }) {
  return (
    <footer {...props} className={`${props.className} flex items-center`}>
      <div className="flex w-full flex-col gap-[60px] sm:gap-[30px]">
        <div className="flex flex-row">
        <div className="flex w-[64%] items-start justify-between gap-5 md:w-full sm:flex-col">
          <Img src="images/img_footer_logo.svg" alt="Footer Logo" className="h-[40px] w-[146px] object-contain" />
        </div>

        <div className="flex w-[48%] items-start justify-between gap-5 self-center md:w-full md:flex-col">
        <ul className="flex w-[88%] flex-col items-start gap-1.5 self-center md:w-full">
              <li>
                <a href="/home" target="_blank" rel="noreferrer">
                  <Text as="p" className="text-[14px] font-normal tracking-[-0.28px] text-white-a700">
                    Home
                  </Text>
                </a>
              </li>
              <li>
                <a href="/about">
                  <Text as="p" className="text-[14px] font-normal tracking-[-0.28px] text-white-a700">
                    About us.
                  </Text>
                </a>
              </li>
              <li>
                <a href="/RiskModel">
                  <Text as="p" className="text-[14px] font-normal tracking-[-0.28px] text-white-a700">
                    Risk Model
                  </Text>
                </a>
              </li>
              <li>
                <a href="/dashboard" target="_blank" rel="noreferrer">
                  <Text as="p" className="text-[14px] font-normal tracking-[-0.28px] text-white-a700">
                    Dashboard
                  </Text>
                </a>
              </li>
              <li>
                <a href="/solutions" target="_blank" rel="noreferrer">
                  <Text as="p" className="text-[14px] font-normal tracking-[-0.28px] text-white-a700">
                  Solutions
                  </Text>
                </a>
              </li>
              <li>
                <a href="/BetaVersion" target="_blank" rel="noreferrer">
                  <Text as="p" className="text-[14px] font-normal tracking-[-0.28px] text-white-a700">
                  Beta Version
                  </Text>
                </a>
              </li>

            </ul>
          </div>


          <div className="flex flex-col items-start gap-1.5">
            <Text as="p" className="text-[14px] font-normal text-white-a700">
              info@tailriskglobal.com
            </Text>
            <Text as="p" className="text-[14px] font-normal tracking-[-0.28px] text-white-a700">
              <span>50 Bridge St. #609</span> <br />
              <span>Brooklyn, New York, NY 11201</span>
            </Text>
          </div>
        </div>
        


        <div className="flex items-center gap-[26px] md:flex-col">
          <ul className="flex flex-wrap gap-2.5">
            <li>
              <a href="/doc/Privacy_Policy.docx"
                 download="Privacy_Policy.docx"
                 className="cursor-pointer"
                >
                <Text as="p" className="text-[14px] font-normal tracking-[-0.28px] text-white-a700">
                  Privacy Policy
                </Text>
              </a>
            </li>
          </ul>
          
          <div className="mb-2 h-px flex-1 self-end bg-blue_gray-400 md:self-stretch sm:self-auto" />
          <Heading size="headingxs" as="p" className="text-[12px] font-semibold text-blue_gray-400">
            © 2024 Tail Risk Global. All rights reserved.
          </Heading>
        </div>
      </div>
    </footer>
  );
}
